// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/tailwindcss.css
// module id = 1139
// module chunks = 68